import React from 'react'
import { Link } from 'react-router-dom'
import constants from '../../constants'
import { NavLink, withRouter } from 'react-router-dom'
import MenuItem from './menu_item'
import { Element , Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'
import { BrowserView, MobileView, isBrowser, isMobile } from "react-device-detect";

class WizardNav extends React.Component {
  constructor(props) {
    super(props);
    this.titles = {
      [constants.ROUTES.HOME]: {title: 'Конструкция', num: '1'},
      [constants.ROUTES.STEP2]: {title: 'Размеры', num: '2'},
      [constants.ROUTES.STEP3]: {title: 'Внешний вид', num: '3'},
      [constants.ROUTES.STEP4]: {title: 'Замки и фурнитура', num: '4'},
      [constants.ROUTES.STEP5]: {title: 'Доп. опции', num: '5'},
      [constants.ROUTES.ORDER]: {title: 'Заказ сейф-двери', num: '6'},
    };
    this.state = {
      menuOpened: false
    };
  }

  toggleNav() {
    this.setState({
      menuOpened: !this.state.menuOpened
    });
  }

  menuChosen = (e) => {
    if (isMobile) {
      setTimeout(() => {
        let y = document.getElementById('js-page-content-top').getBoundingClientRect().y + window.scrollY;
        scroll.scrollTo(y, {
          duration: 200
        });
      }, 10);
      this.setState({
        menuOpened: false
      });
    }
  };

  get currentStepTitle() {
    let path = this.titles[this.props.location.pathname];
    return (<div
      className={`nav-toggle item-${path.num} `}
      onClick={ this.toggleNav.bind(this) }
    >
      <span className='step-number'>{path.num}</span>
      <span className='step-title'>{path.title}</span>
    </div>);
  }

  render() {
    return (
      <section className={`wizard-steps-section ${this.state.menuOpened ? 'active' : ''}`}>
        <div className="toggle-nav-menu">
          { this.currentStepTitle }
        </div>
        <div className='base-width clearfix'>
          <ul className='wizard-steps-navigation-list'>
            <MenuItem wrapperClassName="item-1" onClick={ this.menuChosen } to={constants.ROUTES.HOME}>
              <span className='step-number'>1</span>
              <span className='step-title'>Конструкция</span>
            </MenuItem>
            <MenuItem wrapperClassName="item-2" onClick={ this.menuChosen } to={constants.ROUTES.STEP2}>
              <span className='step-number'>2</span>
              <span className='step-title'>Размеры</span>
            </MenuItem>
            <MenuItem wrapperClassName="item-3" onClick={ this.menuChosen } to={constants.ROUTES.STEP3}>
              <span className='step-number'>3</span>
              <span className='step-title'>Внешний вид</span>
            </MenuItem>
            <MenuItem wrapperClassName="item-4" onClick={ this.menuChosen } to={constants.ROUTES.STEP4}>
              <span className='step-number'>4</span>
              <span className='step-title'>Замки и фурнитура</span>
            </MenuItem>
            <MenuItem wrapperClassName="item-5" onClick={ this.menuChosen } to={constants.ROUTES.STEP5}>
              <span className='step-number'>5</span>
              <span className='step-title'>Доп. опции</span>
            </MenuItem>
          </ul>
        </div>
      </section>
    )
  }
}

export default withRouter(WizardNav);


// WEBPACK FOOTER //
// ./app/javascript/app/components/wizard_nav/index.jsx